import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { requester } from 'App';
import CustomButton from 'components/buttons/CustomButton';
import { useTranslation } from 'react-i18next';
import Center from 'layouts/wrapper/Center';
import P from 'components/P';
import style from './StoreSelection.module.css';

const StoreSelection = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // 매장 목록 조회
        requester.findAllStores((result) => {
            if (result.data) {
                setStores(result.data);
            }
            setLoading(false);
        });
    }, []);

    // 매장 선택 시 해당 매장의 매핑 페이지로 이동
    const handleStoreSelect = (storeId, storeName) => {
        // 절대 경로로 전체 경로 지정
        navigate(`/admin/vending/mapping/${storeId}`, { state: { storeName } });
    };

    if (loading) {
        return <Center><P>로딩 중...</P></Center>;
    }

    return (
        <div className={style.storeSelectionContainer}>
            <Center width={"100%"} textAlign={"left"}>
                <P size={40} font={"gmarketSansBold"}>
                    기기 매핑 - 매장 선택
                </P>
            </Center>

            <div className={style.storeGrid}>
                {stores.map(store => (
                    <div
                        key={store.id}
                        className={style.storeCard}
                        onClick={() => handleStoreSelect(store.id, store.storeName)}
                    >
                        <div className={style.storeName}>{store.storeName}</div>
                        <div className={style.storeAddress}>{store.address}</div>
                        <CustomButton
                            text={"매핑 관리"}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleStoreSelect(store.id, store.storeName);
                            }}
                            style={{ marginTop: '10px' }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StoreSelection;